angular
  .module('qkr')
  .controller('RegistrationController', function(
    $scope,
    merchantService,
    merchantShadowService,
    systemSettingsService,
    $uibModal,
    $window,
    utils,
    appConfig,
    messageService,
    gettextCatalog,
    appUrl,
    OutletFormService,
    outletService,
    partnerService,
    partners,
    user,
    businessCategories,
    $filter,
    taxService,
    APP_CONSTANT,
    merchantUtilService,
    integrationConstant,
    integrationSettingsService,
    integrationHelperService,
    _
  ) {
    const vm = this;
    vm.showUser = false;
    vm.isForbidden = !(appConfig.isMCAdmin || appConfig.isPartner);
    vm.isMCAdmin = appConfig.isMCAdmin;
    vm.isPartner = appConfig.isPartner;
    vm.showTaxControls = false;
    vm.showCustomRegionTaxControls = false;
    vm.showEmailWarning = false;
    vm.currency = '';
    vm.showProfileValidation = false;
    vm.partners = partners;

    // new integration settings private function
    const oldIntegrationCode = () =>
      vm.form.businessCategory && !vm.isSingleOutlet() && !vm.isCharity();
    const setVisibleFeature = () => {
      vm.visible = { isIntegrationSettings: oldIntegrationCode() };
    };
    // end integration settings private function
    vm.form = {};

    vm.ISO_CODE_AUSTRALIA = 'AU';
    vm.ISO_CODE_UK = 'GB';
    vm.ISO_CODE_UAE = 'AE';

    vm.checkPermission = function() {
        if(vm.isForbidden) {
            $window.location.href = appConfig.logoutUrl + '?timeout=true';
        }
    };

    vm.init = function() {
      vm.checkPermission();
      vm.form.supportedTimezone = {};
      vm.form.supportedTimezone.id = 1;
      vm.form.website = '';
      vm.form.name = '';
      vm.form.merchantRegistrationId = '';
      vm.form.costCenter = '';
      vm.form.enableProfileValidation = false;
      vm.form.enableSubsidisedProduct = false;
      vm.form.beneficiaryDailyAllowance = '';
      vm.form.partner = null;

      vm.saving = false;

      // new integration settings
      vm.location = integrationConstant.LOCATION.merchantCreation.label;
      setVisibleFeature();
      // end new integration settings
      vm.businessCategories = [];

      vm.preferredLanguages = [
        { name: gettextCatalog.getString('English'), value: 'en' },
        { name: gettextCatalog.getString('Spanish'), value: 'es' }
      ];

      // Need be the same that the dialog because are sharing the service form
      vm.outlet = OutletFormService.outlet;
      vm.customRegionTax = OutletFormService.customRegionTax;

      vm.maxLengthName = OutletFormService.maxLengthName;

      vm.setupBusinessCategories();

      systemSettingsService.loadSupportedCountries().then(promise => {
        vm.countries = promise;
        vm.countriesIso = [];

        _.remove(vm.countries, function(n) { // QKRD-9110 hide HK
          return n.name === "Hong Kong";
        });
        // Indexing by isoCode
        angular.forEach(vm.countries, value => {
          vm.countriesIso[value.isoCode] = value;
        });

        systemSettingsService.loadAccountancyPackage().then(promise => {
          vm.accountancies = promise;

          vm.setCountryPreAction();
        }, reason => {
          messageService.error('loadAccountancyPackage error', reason);
        });
      }, reason => {
        messageService.error('loadSupportedCountries error', reason);
      });
    };

    vm.setupBusinessCategories = function() {

        if (vm.isMCAdmin) {
          vm.businessCategories = businessCategories;
        } else if(vm.isPartner) {
          vm.getPartnerCategories(businessCategories);
        } else {
          vm.businessCategories = $filter('filter')(businessCategories, {
            'name': '!' + 'Charity'
          });
        }
    };

    vm.getPartnerCategories = function(businessCategories) {
      if(vm.isPartner && vm.partners) {
        const partner = vm.partners.find(partner => partner.id === user.partner.id);
        if (partner && partner.allowedBusinessCategories) {
          vm.businessCategories =
              updateBusinessCategories(businessCategories, partner.allowedBusinessCategories)
        }
      }
    };

    /** Update Business Category list shown on form from list of category and set the ones that should be displayed */
    const updateBusinessCategories = function(businessCategories, allowedBusinessCategories) {
      let partnerBusinessCategories = [];
      businessCategories.forEach ( category => {
        allowedBusinessCategories.forEach (allowedCategory => {
          if (category.id === parseInt(allowedCategory, 10)) {
            partnerBusinessCategories.push(category);
          }
        })
      });
      return partnerBusinessCategories;
    };

    // new integration settings, dataOutputConverted is converted to original(back end format)
    vm.mergeToForm = dataOutputConverted => {
      vm.form = _.defaults(dataOutputConverted, vm.form);
      const flattenData = integrationHelperService.convertServerDataToFlatten(vm.form);
      const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
      vm.isPos = integrationDetails.isPos;
    };
    // end new integration settings method
    vm.isCharity = function() {
      return merchantUtilService.isCharity(vm.form.businessCategory);
    };
    vm.isSingleOutlet = function() {
      return merchantUtilService.isSingleOutlet(vm.form.businessCategory);
    };

    vm.isVendingMerchant = function() {
      if (vm.form.businessCategory) {
        return vm.form.businessCategory.name ===
          APP_CONSTANT.BusinessCategory.VENDING;
      }
      return false;
    };

    vm.showAccountantancyOption = function() {
      return merchantUtilService.isSingleOutlet(vm.form.businessCategory) &&
        (vm.form.countryIsoCode === vm.ISO_CODE_AUSTRALIA ||
          vm.form.countryIsoCode === vm.ISO_CODE_UAE ||
          vm.form.countryIsoCode === vm.ISO_CODE_UK) &&
        vm.form.businessCategory.name !== 'Supplier';
    };

    vm.showMerchantRegistrationId = function() {
      return vm.isCategorySchool();
    };

    vm.showCostCenter = function() {
      return vm.isCategorySchool() &&
        vm.matchesCountryAndPackage(vm.ISO_CODE_UK, 'ICON');
    };

    vm.showProfileValidation = function() {
      if (vm.isCategorySchool()) {
        if (vm.matchesCountryAndPackage(vm.ISO_CODE_UK, 'ICON')) {
          return true;
        } else {
          vm.form.enableProfileValidation = false;
        }
      }
      return false;
    };

    vm.isMerchantRegistrationRequired = function() {
      return vm.isCategorySchool() &&
        (vm.matchesCountryAndPackage(vm.ISO_CODE_UK, 'ICON') ||
          vm.matchesCountryAndPackage(
            vm.ISO_CODE_AUSTRALIA,
            APP_CONSTANT.FINANCE1_REPORT
          ));
    };

    vm.showSubsidisedProduct = function() {
      return vm.isProfileValidationEnableForSchool();
    };

    vm.showBeneficiaryAllowance = function() {
      return vm.isProfileValidationEnableForSchool() &&
        vm.form.enableSubsidisedProduct;
    };

    vm.resetSubsidisedSection = function() {
      if (vm.form.enableProfileValidation) {
        vm.showSubsidisedProduct();
      } else {
        vm.showSubsidisedProduct();
        vm.form.enableSubsidisedProduct = false;
        vm.form.beneficiaryDailyAllowance = '';
      }
    };

    vm.resetProfileValidation = function() {
      vm.form.enableProfileValidation = false;
      vm.form.merchantRegistrationId = '';
      vm.resetSubsidisedSection();
    };

    vm.isCategorySchool = function() {
      return vm.form.businessCategory &&
        vm.form.businessCategory.name === 'School';
    };

    vm.matchCountry = function(...countries) {
      return countries.includes(vm.form.countryIsoCode);
    };

    vm.matchesCountryAndPackage = function(country, accountancyPackage) {
      if (vm.form.countryIsoCode === country) {
        let matchedPackage = vm.countryAccountancies.find(
          it => it.id === vm.form.accountancyPackage.id
        );
        if (matchedPackage)
          return matchedPackage.name === accountancyPackage;
      }
      return false;
    };

    vm.isProfileValidationEnableForSchool = function() {
      return vm.isCategorySchool() && vm.form.enableProfileValidation;
    };

    vm.managePartnerBizCat = function() {
        if(vm.form.partner && vm.form.partner.allowedBusinessCategories) {
          vm.businessCategories =
              updateBusinessCategories(businessCategories, vm.form.partner.allowedBusinessCategories)
        } else {
          vm.businessCategories = businessCategories
        }
    };

    vm.manageBizCat = function() {
      if (merchantUtilService.isSingleOutlet(vm.form.businessCategory)) {
        vm.showOutlet = true;
      }

      vm.setCountryPreAction();
      setVisibleFeature();
    };

    vm.setCountryPreAction = function() {
      vm.loadCountryAccountancyPackage();

      vm.form.accountancyPackage = {};
      if (
        merchantUtilService.isSingleOutlet(vm.form.businessCategory) &&
          vm.countryAccountancies
      ) {
        for (let i = 0; i < vm.countryAccountancies.length; i++) {
          if (
            vm.countryAccountancies[i].name === 'Cases21' ||
              vm.countryAccountancies[i].name === 'ICON'
          ) {
            vm.form.accountancyPackage.id = vm.countryAccountancies[i].id;
          }
        }
      }

      const selectedCountry = getCountryForISOCode(vm.form.countryIsoCode);
      vm.showTaxControls = canShowTaxControls(selectedCountry);
      vm.showCustomRegionTaxControls = canShowCustomRegionTaxControls(
        vm.form.taxCalculationsEnabled,
        selectedCountry
      );

      if (vm.showTaxControls && selectedCountry != null) {
        vm.customRegionTax.name = selectedCountry.defaultSalesTaxName;
      } else {
        resetTaxControls();
      }
      vm.currency = getCurrencyISOCode(selectedCountry);
      if (!vm.showProfileValidation()) {
        vm.resetProfileValidation();
      }
    };

    vm.loadCountryAccountancyPackage = function() {
      vm.countryAccountancies = [];
      vm.countryAccountancies = vm.accountancies.filter(
        accountancy => accountancy.country.isoCode === vm.form.countryIsoCode
      );
    };

    vm.taxCalculationsToggled = function() {
      const selectedCountry = getCountryForISOCode(vm.form.countryIsoCode);
      vm.showCustomRegionTaxControls = canShowCustomRegionTaxControls(
        vm.form.taxCalculationsEnabled,
        selectedCountry
      );
      vm.customRegionTax.name = selectedCountry.defaultSalesTaxName;
    };

    vm.validateSever = function(response) {
      vm.errors = null;
      const errors = {};

      switch (response.code) {
        case 'username':
          errors.username = response.exception;
          break;
        case 'name':
          errors.name = response.exception;
          break;
        case 'scanId':
          errors.scanId = response.exception;
          break;
      }

      vm.errors = errors;
    };

    function createMerchantAfterPosCheck() {
      stripInvisibleFields();

      if (vm.showOutlet) {
        if (vm.selectStateObj) {
          vm.outlet.state = vm.selectStateObj.name;
        }
        if (vm.isMicros) {
          vm.outlet.useMerchantSettings = true;
        }
        vm.form.outletCommand = vm.outlet;

        outletService
          .getTimeZoneIdGoogle(vm.outlet.latitude, vm.outlet.longitude)
          .then(
            response => {
              if (response.data && response.data.value) {
                vm.outlet.timezoneId = response.data.value;
                carryOutCreateMerchant();
              }
              else {
                messageService.log('No timezone found');
                // If google timezone API cannot resolve timezone, select it from a list within a modal.
                if (!vm.form.countryIsoCode) {
                  messageService.error(
                      gettextCatalog.getString(
                          'No country selected for this merchant'
                      )
                  );
                }

                timezoneModal();
              }
            },
            reason => {
              messageService.log('No timezone found', reason);
              // If google timezone API cannot resolve timezone, select it from a list within a modal.
              if (!vm.form.countryIsoCode) {
                messageService.error(
                  gettextCatalog.getString(
                    'No country selected for this merchant'
                  )
                );
                return;
              }

              timezoneModal();
            }
          );
      } else {
        carryOutCreateMerchant();
      }
    }

    function showPosConfirmationDialog(posTypeName) {
      const modalInstance = $uibModal.open({
          template: require('../../templates/common/modalDialog.html'),
        controller: 'commonModalDialogController',
        windowClass: 'fade',
        backdrop: 'static',
        resolve: {
          title() {
            return gettextCatalog.getString('Confirm POS Type');
          },
          confirmButtonName() {
            return gettextCatalog.getString('Ok');
          },
          confirmMsg() {
            return gettextCatalog.getString(
              'Please confirm that the POS Type '
            ) +
              posTypeName +
              ' is correct.';
          },
          multiMsgArray() {
            return [];
          }
        }
      });

      return modalInstance.result.then(
        result => {
          return result;
        },
        () => {}
      );
    }

    vm.createMerchant = function(isInvalid) {
      if (isInvalid || !vm.validateDailyBeneficiary()) {
        return;
      }

      // new integration settings
      // this is part of the old code, it was settings useMerchantSettings to true if it's micros
      const flattenData = integrationHelperService.convertServerDataToFlatten(vm.form);
      const integrationDetails = integrationSettingsService.integrationDetails(flattenData);
      // replacing the old code
      vm.isPos = integrationDetails.isPos;
      vm.isMicros = integrationDetails.isMicros;

      if (vm.isPos) {
        showPosConfirmationDialog(
          vm.form.merchantPosProperties.posType
        ).then(result => {
          if (result !== 'cancel') {
            createMerchantAfterPosCheck();
          }
        }, reason => {
          messageService.error(reason);
        });
      } else {
        createMerchantAfterPosCheck();
      }
    };

    vm.back = function() {
      $window.history.back();
    };

    vm.isDemo = function() {
      if (vm.form.merchantPosProperties) {
        if (
          vm.form.merchantPosProperties.posType &&
            vm.form.merchantPosProperties.posType === 'Demo'
        ) {
          return true;
        }
      }
      return false;
    };

    vm.showTemplate = function() {
      vm.showOutlet = !vm.showOutlet;
    };

    vm.toUpperCase = function() {
      vm.form.scanId = angular.uppercase(vm.form.scanId);
    };

    vm.displayEmailWarning = function() {
      vm.showEmailWarning = !(utils.hasNoValue(vm.form.username) ||
        vm.form.username.toLowerCase() === vm.form.username);
    };

    $scope.$watch('vm.form.scanId', (newVal, oldVal) => {
      if (newVal && newVal !== oldVal) {
        vm.form.scanId = newVal.toUpperCase();
      }
    });

    $scope.$watch('vm.outlet.addressLine1', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        // To set pristine  $scope.myForm.name.$setPristine();
        // To set whole form  $scope.myForm.$setDirty();
        if ($scope.createForm && $scope.createForm.outletName) {
          // This set the field to $dirty true
          $scope.createForm.outletName.$setViewValue(
            $scope.createForm.outletName.$viewValue
          );

          vm.outlet.name = OutletFormService.changeName();
        }
      }
    });

    $scope.$watch('vm.form.countryIsoCode', (newVal, oldVal) => {
      if (newVal !== oldVal) {
        angular.forEach(vm.countries, country => {
          if (country.isoCode === vm.form.countryIsoCode) {
            vm.stateDisplayName = country.stateDisplayName;
            vm.postcodeDisplayName = gettextCatalog.getString(
              country.postcodeDisplayName
            );
            vm.stateSelectableValues = country.stateSelectableValues;
            vm.selectStateObj = '';
            // vm.displayBusinessCategories = angular.copy(vm.businessCategories)
            if (utils.hasNoValue(vm.stateDisplayName)) {
              vm.stateDisplayName = 'State/County';
            }
          }
        });
      }
    });

    var carryOutCreateMerchant = function() {
      vm.saving = true;

      if (vm.showCustomRegionTaxControls) {
        vm.customRegionTax.region = vm.outlet.state;
      }

      if (vm.form.partner && vm.form.partner.allowedBusinessCategories) {
        vm.form.partner.allowedBusinessCategories = vm.form.partner.allowedBusinessCategories.join(",");
      }
      merchantService.createMerchant(vm.form).then(response => {
        messageService.log(response);

        if (
          vm.showCustomRegionTaxControls &&
            validateCustomRegionTax(vm.customRegionTax)
        ) {
          // Create tax rate for selected region
          taxService
            .createTaxRateForMerchantAndRegion(response.id, vm.customRegionTax)
            .then(salesTaxResponse => {
              $window.location.href = appConfig.contextPath + appUrl.mcAdmin;
            });
        } else {
          $window.location.href = appConfig.contextPath + appUrl.mcAdmin;
        }

        if (vm.form.payAtTable) {
          merchantService.createShareMenuForPos(response);
        }

        if (vm.isVendingMerchant()) {
          merchantShadowService.create(response.id, vm.form);
        }
      }, reason => {
        vm.saving = false;
        messageService.error(reason);
      });
    };

    var timezoneModal = function() {
      const timezoneModalInstance = $uibModal.open({
        template: require('../../templates/timezone/timezone.html'),
        controller: 'TimezoneController as timezoneCtrl',
        windowClass: 'modal-small',
        backdrop: 'static',
        resolve: {
          timezones() {
            let matchedCountry = null;

            if (vm.form.countryIsoCode) {
              for (let i = 0; i < vm.countries.length; i++) {
                const country = vm.countries[i];
                if (country.isoCode === vm.form.countryIsoCode) {
                  matchedCountry = country;
                }
              }
            }

            return matchedCountry != null ? matchedCountry.timezones : null;
          }
        }
      });

      timezoneModalInstance.result.then(result => {
        if (result !== 'cancel') {
          vm.outlet.timezoneId = result;
          carryOutCreateMerchant();
        }
      });
    };

    var stripInvisibleFields = function() {
      // Copied ng-if from html page
      // Timezone
      if (!(vm.countriesIso[vm.form.countryIsoCode].timezones.length > 1)) {
        if (
          !utils.hasNoValue(
            vm.countriesIso[vm.form.countryIsoCode].timezones[0]
          )
        ) {
          vm.form.supportedTimezone = vm.countriesIso[vm.form.countryIsoCode].timezones[0];
        }
      }

      // Account package
      if (
        !((vm.form.countryIsoCode === vm.ISO_CODE_AUSTRALIA ||
          vm.form.countryIsoCode === vm.ISO_CODE_UK) &&
          merchantUtilService.isSingleOutlet(vm.form.businessCategory))
      ) {
        vm.form.accountancyPackage = {};
        vm.form.accountancyPackage.id = null;
      }
    };

    var resetTaxControls = function() {
      vm.showCustomRegionTaxControls = false;
      vm.form.taxCalculationsEnabled = false;
      vm.form.pricesSetPretax = false;
      vm.customRegionTax = OutletFormService.customRegionTax;
    };

    var canShowTaxControls = function(country) {
      let showTaxControls = false;

      if (
        country != null &&
          !merchantUtilService.isCharity(vm.form.businessCategory)
      ) {
        if (country.taxationCalculationsEnabled != null) {
          showTaxControls = country.taxationCalculationsEnabled;
        }
      }

      return showTaxControls;
    };

    var canShowCustomRegionTaxControls = function(taxEnabled, country) {
      let showCustomRegionTaxControls = false;

      if (taxEnabled) {
        if (country != null) {
          if (country.taxationMerchantRegionOverride != null) {
            showCustomRegionTaxControls = country.taxationMerchantRegionOverride;
          }
        }
      }

      return showCustomRegionTaxControls;
    };

    var getCountryForISOCode = function(countryISOCode) {
      if (countryISOCode != null) {
        for (let i = 0; i < vm.countries.length; i++) {
          const countryInList = vm.countries[i];
          if (countryInList.isoCode == countryISOCode) {
            return countryInList;
          }
        }
      }

      return null;
    };

    var getCurrencyISOCode = function(selectedCountry) {
      if (
        selectedCountry != null &&
          vm.countriesIso[selectedCountry.isoCode] != null
      ) {
        return vm.countriesIso[selectedCountry.isoCode].currency.isoCode;
      }
      return null;
    };

    var validateCustomRegionTax = function(customRegionTax) {
      if (customRegionTax == null) {
        return false;
      }

      if (
        utils.hasNoValue(customRegionTax.rate) ||
          utils.hasNoValue(customRegionTax.name) ||
          utils.hasNoValue(customRegionTax.region)
      ) {
        return false;
      }

      return true;
    };

    // Keep it as last call
    // vm.init bound to the module only because is the only way I found to call from the test
    vm.init();

    // Beneficiary Daily Allowance amount should greater than 0.00
    vm.validateDailyBeneficiary = function() {
      return !vm.form.enableSubsidisedProduct ||
        vm.form.enableSubsidisedProduct &&
          vm.form.beneficiaryDailyAllowance > 0;
    };

    vm.isPretaxVisible = () => {
        return vm.form.taxCalculationsEnabled && vm.isPos;
    };
  });



// WEBPACK FOOTER //
// ./src/controllers/mastercard/registration.controller.js